import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { BsFillCalendarDayFill, BsCheck2All, BsFillQuestionCircleFill } from "react-icons/bs";
import { RiMessage2Fill, RiSendPlaneFill } from "react-icons/ri";

function Content({ caption, add, className }) {
    return (
        <div className={className}>
            <h1 className=" text-sky-300">{caption} </h1>
            <div>{add}</div>
        </div>
    );
}

function IconNote({ id }) {
    return (
        <div id={id} className="content mb-6 flex gap-4 w-fit justify-center items-center mx-auto bg-slate-800 hover:bg-slate-800 bg-opacity-60 border-4 border-slate-800 p-4 shrink-0 text-slate-200 rounded-lg">
            <Content className="content flex flex-col justify-center items-center sm:flex-row sm:justify-start gap-1 flex-wrap" caption={<BsFillCalendarDayFill className=" mr-2" size={"20px"} />} add={"Time"} />
            {" | "}
            <Content className="content flex flex-col justify-center items-center sm:flex-row sm:justify-start gap-1 flex-wrap" caption={<BsCheck2All className=" mr-2" size={"20px"} />} add={"From"} />
            {" | "}
            <Content className="content flex flex-col justify-center items-center sm:flex-row sm:justify-start gap-1 flex-wrap" caption={<RiSendPlaneFill className=" mr-2" size={"20px"} />} add={"To"} />
            {" | "}
            <Content className="content flex flex-col justify-center items-center sm:flex-row sm:justify-start gap-1 flex-wrap" caption={<RiMessage2Fill className=" mr-2" size={"20px"} />} add={"Message"} />
        </div>
    );
}

function Confession() {
    const [dataConfession, setDataConfession] = useState([]);

    const [searchTerm, setSearchTerm] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    const searchHandler = (searchTerm) => {
        setSearchTerm(searchTerm);
    };

    const inputEl = useRef("");
    const getSearchTerm = () => {
        searchHandler(inputEl.current.value);
        if (searchTerm !== "") {
            const newDataList = dataConfession.filter((data) => {
                return Object.values(data).join(" ").toLowerCase().includes(searchTerm.toLowerCase());
            });
            setSearchResult(newDataList);
        } else if (searchTerm === "") {
            setSearchResult(dataConfession);
        }
    };

    useEffect(() => {
        Axios.get("https://script.google.com/macros/s/AKfycbzQRwBeHHLkubvdCZmI6E31VXRVhPjokdhnQI1ZGnogMfg-TCB4S5MhC4561H6IdEKk/exec?action=getUsers")
            .then((res) => {
                const array = res.data;
                setDataConfession(array);
            })
            .catch((err) => {
                alert("Whoa! Seem's like there's an error, please try again or refresh the page.");
            });
    }, []);

    function DataConfession() {
        if (searchTerm.length === 0) {
            return dataConfession
                .slice()
                .reverse()
                .map((data, idx) => {
                    return (
                        <div className="content flex flex-col bg-slate-800 hover:bg-slate-800 bg-opacity-60 border-4 border-slate-800 h-max p-4 shrink-0 text-slate-200 rounded-lg" key={idx}>
                            <Content className="content lg:mb-4 mb-2 flex gap-1 flex-wrap" caption={<BsFillCalendarDayFill className=" mr-2" size={"20px"} />} add={data.Timestamp.slice(0, 10)} />
                            <Content className="content lg:mb-4 mb-2 flex gap-1 flex-wrap" caption={<BsCheck2All className=" mr-2" size={"20px"} />} add={data.From} />
                            <Content className="content lg:mb-4 mb-2 flex gap-1 flex-wrap" caption={<RiSendPlaneFill className=" mr-2" size={"20px"} />} add={data.To} />
                            <Content className="content lg:mb-4 mb-2 flex gap-1 flex-wrap" caption={<RiMessage2Fill className=" mr-2" size={"20px"} />} add={data.Message} />
                        </div>
                    );
                });
        } else if (searchResult.length === 0) {
            return (
                <div className="content justify-center flex flex-col bg-slate-800 hover:bg-slate-800 bg-opacity-60 border-4 border-slate-800 h-max p-4 shrink-0 text-slate-200 rounded-lg">
                    <h1>No data found</h1>
                </div>
            );
        } else {
            return searchResult.map((data, idx) => {
                return (
                    <div className="content flex flex-col bg-slate-800 hover:bg-slate-800 bg-opacity-60 border-4 border-slate-800 h-max p-4 shrink-0 text-slate-200 rounded-lg" key={idx}>
                        <Content className="content lg:mb-4 mb-2 flex gap-1 flex-wrap" caption={<BsFillCalendarDayFill className=" mr-2" size={"20px"} />} add={data.Timestamp.slice(0, 10)} />
                        <Content className="content lg:mb-4 mb-2 flex gap-1 flex-wrap" caption={<BsCheck2All className=" mr-2" size={"20px"} />} add={data.From} />
                        <Content className="content lg:mb-4 mb-2 flex gap-1 flex-wrap" caption={<RiSendPlaneFill className=" mr-2" size={"20px"} />} add={data.To} />
                        <Content className="content lg:mb-4 mb-2 flex gap-1 flex-wrap" caption={<RiMessage2Fill className=" mr-2" size={"20px"} />} add={data.Message} />
                    </div>
                );
            });
        }
    }

    return (
        <React.Fragment>
            <div className="container w-full mx-auto font-poppins">
                <header className="mx-auto pt-32">
                    <h1 className="text-center text-3xl font-bold text-sky-400">All Your Confession</h1>
                </header>
                <div name="confessionForm" className="lg:w-9/12  h-screen w-11/12 my-10 flex flex-col  mx-auto bg-slate-800 bg-opacity-50 border-4 border-slate-800 rounded-xl">
                    <div className="search flex flex-col-reverse lg:flex-row justify-between items-center gap-3 px-8 py-4 lg:py-4">
                        <a href="#icon" className="text-slate-200 items-center flex gap-4 hover:underline">
                            <BsFillQuestionCircleFill />
                            Icon means?
                        </a>
                        <input type="text" ref={inputEl} placeholder="Search..." value={searchTerm} onChange={getSearchTerm} className="prompt bg-slate-900 text-white border-slate-700 form-input block rounded-lg w-full md:w-1/3" />
                    </div>
                    <div className="data grid overflow-auto lg:grid-cols-3 gap-4 grid-cols-1 md:grid-cols-2 lg:p-6 px-8 py-4 justify-items-stretch mx-auto rounded-xl">
                        <DataConfession term={searchTerm} searchKeyword={searchHandler} />
                    </div>
                </div>
                <IconNote id="icon" />
            </div>
        </React.Fragment>
    );
}

export default Confession;
